import React from 'react';
import { motion, Variants } from 'framer-motion';
import { FEATURE_CARDS } from '../content';

const ICON_SRC: Record<string, string> = {
  network: '/images/landing/feature-network.svg',
  savings: '/images/landing/feature-savings.svg',
  clock: '/images/landing/feature-clock.svg',
};

const Icon: React.FC<{ name: string }> = ({ name }) => {
  const src = ICON_SRC[name] ?? ICON_SRC.clock;
  // The source files are raster icons; tint them with a CSS mask so they keep
  // the current icon color (#9c958a) regardless of their baked-in colors.
  return (
    <span
      aria-hidden
      className="block size-8"
      style={{
        backgroundColor: '#9c958a',
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
      }}
    />
  );
};

const cardV = (index: number): Variants => ({
  hidden: {},
  show: { transition: { staggerChildren: 0.16, delayChildren: index * 0.2 } },
});
const iconV: Variants = {
  hidden: { opacity: 0, scale: 0.5 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.4, ease: 'easeOut' } },
};
const textV: Variants = {
  hidden: { opacity: 0, y: 26 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: 'easeOut' } },
};

export const FeatureCards: React.FC = () => {
  return (
    <section className="px-4 md:px-8">
      <div className="mx-auto grid max-w-[1180px] gap-5 md:grid-cols-3">
        {FEATURE_CARDS.map((card, i) => (
          <motion.div
            key={card.text}
            variants={cardV(i)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.5 }}
            className="flex min-h-[150px] items-center gap-6 overflow-hidden rounded-2xl bg-[#f5eee2] p-7"
          >
            <motion.div
              variants={iconV}
              className="flex size-16 shrink-0 items-center justify-center rounded-full bg-[#DED7C8] text-[#9c958a]"
            >
              <Icon name={card.icon} />
            </motion.div>
            <motion.p
              variants={textV}
              className="text-[22px] font-extrabold leading-[1.15] tracking-tight text-[#23262C]"
            >
              {card.text}
            </motion.p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
